module.exports = __webpack_public_path__ + "media/images/game_icon/en/BC1039-4824fdce3565c56af03ee60ed1b2b7d5.png";